<!-- Content Editor Container -->
<div class="content-editor-container" [class.minimized]="isMinimized" #modalContainer>
  <!-- Header -->
  <div class="content-editor-header">
    <div class="header-content">
      <div class="logo">
        <i class="fas fa-edit"></i>
        <h1>Edit Content</h1>
      </div>
      <div class="editor-controls">
        <button class="control-btn" (click)="cancelEdit()" title="Close Editor">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Form Area -->
  <form class="content-editor-form" (ngSubmit)="onUpdate()">
    <div class="form-group">
      <div class="content-comparison-row">
        <div class="comparison-panel">
          <label class="comparison-label">Original Content</label>
          <textarea class="comparison-textarea" [disabled]="true" [value]="originalContent" readonly></textarea>
        </div>
        <div class="comparison-panel">
          <label class="comparison-label">Your Changes</label>
          <div class="textarea-container">
            <textarea id="existingContent" class="comparison-textarea" [(ngModel)]="newContent" name="existingContent" rows="10" #contentTextarea></textarea>
            <div class="content-action-buttons" *ngIf="showAcceptReject">
              <button type="button" class="content-action-btn reject-btn" (click)="keepOldContentAction()" title="Reject and keep original">
                Reject
              </button>
              <button type="button" class="content-action-btn accept-btn" (click)="useNewContent()" [disabled]="!newContent.trim()" title="Accept this content">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group">
      <div class="textarea-container">
        <textarea id="userFeedback" class="form-textarea" [(ngModel)]="userFeedback" name="userFeedback" rows="3" placeholder="Describe your changes, and get it generated via OTTO Agent" #feedbackInput></textarea>
        <button type="button" class="generate-btn" (click)="regenerateContent()" [disabled]="!userFeedback.trim() || isGenerating" title="Generate with AI">
          <i class="fas fa-arrow-up" *ngIf="!isGenerating"></i>
          <i class="fas fa-spinner fa-spin" *ngIf="isGenerating"></i>
        </button>
      </div>
    </div>
    <div class="form-actions">
      <button type="submit" class="btn btn-primary" [disabled]="!newContent.trim()">Update</button>
      <button type="button" class="btn btn-secondary" (click)="cancelEdit()">Cancel</button>
    </div>
  </form>
</div> 